import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import FutureFollowup from "../../components/Followups/Future"

const FollowupFuture = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Future Followups | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <FutureFollowup />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FollowupFuture
